import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import FormControl from "@mui/material/FormControl";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ImageNotSupported } from "@mui/icons-material";

export default function Details ({ open, queryDetails, handleClose }) {
  const theme = useTheme();
  const color = { color: "rgba(0,0,0,0.7" };
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogTitle id='responsive-dialog-title'>{"Buy Lead Details"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(0,0,0,0.4)",
                borderRadius: "8px",
                padding: "6px",
              }}
            >
              <label style={color}>Basic Details</label>
              <div style={{ display: "flex", fontSize: "14px", gap: "16px" }}>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Name: </span>
                  {queryDetails?.name}
                </div>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Email: </span>
                  {queryDetails?.email}
                </div>
              </div>
              <div style={{ display: "flex", fontSize: "14px", gap: "16px" }}>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Number: </span>
                  {queryDetails?.number}
                </div>
                <div style={{ padding: "4px" }}>
                  <span style={color}>Place: </span>
                  {queryDetails?.place}
                </div>
              </div>
            </div>

            <div style={{ border: "1px solid #ccc", borderRadius: "8px", padding: "12px" }}>
              <h4 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}>Products</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {queryDetails?.productDetail?.map((product, index) => (
                  <div
                    key={product.productId}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px dashed #ccc",
                      padding: "10px",
                      borderRadius: "6px",
                      gap: "16px",
                    }}
                  >
                    {!product.images && product.images?.length !== "0" ? (
                      <img
                        src={product?.images[0]?.image}
                        alt={product.name}
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "contain",
                          borderRadius: "8px",
                          backgroundColor: "#f5f5f5",
                          border: "1px solid #ddd",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          height: "80px",
                          width: "80px",
                          border: "1px solid",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: '6px'
                        }}
                      >
                        <ImageNotSupported sx={{ fontSize: "50px" }} />
                      </div>
                    )}
                    <div style={{ fontSize: "14px" }}>
                      <div onClick={() => redirect(product)} style={{ cursor: "pointer" }}>
                        <strong>Name:</strong> {product.name}
                      </div>
                      <div>
                        <strong>Quantity:</strong> {product.quantity}
                      </div>
                      <div>
                        <strong>Price:</strong> ₹{product.discountPrice}{" "}
                        <span
                          style={{ textDecoration: "line-through", fontSize: "12px", color: "red" }}
                        >
                          ₹{product.price}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid rgba(0,0,0,0.4)",
                borderRadius: "8px",
                padding: "6px",
                marginTop: "10px",
                fontSize: "14px",
              }}
            >
              <span style={color}>Products Details: </span>
              <div style={{ padding: "4px" }}>
                <span style={color}>Category: </span>
              </div>
              <div style={{ padding: "4px" }}>
                <span style={color}>Details: </span>
                {queryDetails?.text}
              </div>
            </div> */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    // marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100%",
    height: "120px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};
